var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarouselArrowLeft = function SvgCarouselArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64 10.94a.667.667 0 0 1-.987 0L.205 6.187a.785.785 0 0 1 0-1.057L4.653.377a.667.667 0 0 1 .988 0 .784.784 0 0 1 0 1.057L2.387 4.912H20.75v1.494H2.387L5.64 9.884a.784.784 0 0 1 0 1.056"
  })));
};
export default SvgCarouselArrowLeft;